var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmallHeavy = function SvgSmallHeavy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9043 6.49902L44.0391 6.6377L44.0664 6.83008L45.3037 15.3965C45.9125 15.6155 46.3496 16.1964 46.3496 16.8799V26.6582C46.3494 27.5285 45.6418 28.2362 44.7715 28.2363H41.5518V30.4482H39.71V31.3799H41.5518V33.6182H45.8652V69.6455H26.1992V33.6182H30.625V31.3799H32.1719V30.4482H30.625V28.2363H27.2285C26.3581 28.2363 25.6506 27.5286 25.6504 26.6582V16.8799C25.6504 16.2005 26.0815 15.6215 26.6846 15.3994L27.75 6.71387L27.8896 6.56934L30.9902 3.36719H40.8779L43.9043 6.49902Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14814_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.444 -61.8945H-340.855V171.557H247.444V-61.8945Z",
    stroke: "black",
    strokeWidth: 3.63545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8001 33.7607H26.6309V69.2106H45.8001V33.7607Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8301 36.6978H45.6526V69.4601L40.4741 60.3482V38.9384H32.108V60.4476L27.0789 69.061L26.8301 36.6978Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3228 31.7056H31.3477V34.0393H41.3228V31.7056Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3228 27.4893H31.3477V29.8214H41.3228V27.4893Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.479 29.8984H32.8926V31.6303H39.479V29.8984Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5114 34.0674H27.0449V68.895H45.5114V34.0674Z",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1758 36.5625H45.3996",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4043 36.6875L32.2854 38.8412V60.525L27.4043 69.0601",
    stroke: "black",
    strokeWidth: 0.99133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2733 36.6875L40.3945 38.8412V60.525L45.2733 69.0601",
    stroke: "black",
    strokeWidth: 0.99133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2852 38.8418H40.3312",
    stroke: "black",
    strokeWidth: 0.99133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2852 60.5249H40.3938",
    stroke: "black",
    strokeWidth: 0.99133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0173 15.7512C45.5565 15.7512 45.9956 16.1902 45.9956 16.7294V26.5074C45.9956 27.0466 45.5565 27.4856 45.0173 27.4856H27.4744C26.9351 27.4856 26.4961 27.0466 26.4961 26.5074V16.7294C26.4961 16.1902 26.9351 15.7512 27.4744 15.7512L28.5669 6.83649L31.4907 3.81641H40.8695L43.719 6.76527L45.0173 15.7512Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5129 27.4744V15.5529L39.6895 3.87012",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8508 3.87012L31.0273 15.5529V27.436",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0273 15.5525L33.0222 13.4434H39.7464L41.5135 15.7239",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0645 10.5068H31.8648",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7168 10.5068H44.5171",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0234 24.998H41.5033",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4883 24.5925V15.8023L32.4376 14.7168V24.5925H31.4883Z",
    stroke: "black",
    strokeWidth: 0.952122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.977 24.5925V15.8023L40.0293 14.7168V24.5925H40.977Z",
    stroke: "black",
    strokeWidth: 0.952122
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14814_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8261,
    height: 72,
    fill: "white",
    transform: "translate(23.1875 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmallHeavy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "small-heavy.6d8190aaa65afbdf673332b580d6560f.svg";